<template>
  <div class="btn-menu one-page-menu flex bg-white">
    <div class="inline-flex sm:block">
      <button v-for="(name, id) in sections" v-scroll-to="'#'+id" class="bg-white hover:bg-red text-grey-darkest hover:text-white font-bold py-5 px-10 sm:w-full">
        {{ name }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'onePageMenu',
    props: {
      sections: {
        type: Object
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/menus/onePageMenu.vue